import { render, staticRenderFns } from "./trait-grants.vue?vue&type=template&id=f1498ea6&lang=pug&"
import script from "./trait-grants.vue?vue&type=script&lang=js&"
export * from "./trait-grants.vue?vue&type=script&lang=js&"
import style0 from "./trait-grants.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports